import React from "react";

const TopBar = ({ toggleSidebar, handleLogout }) => {
    return (
        <div className="top-bar">
            {/* Mobile toggle button on the left (visible on mobile only) */}
            <button className="sidebar-toggle" onClick={toggleSidebar}>
                ☰
            </button>
            <h2>Admin Panel</h2>
            <div className="spacer" />
            <button className="logout-btn" onClick={handleLogout}>
                Logout
            </button>
        </div>
    );
};

export default TopBar;
